import { useMemo } from 'react'
import { useApiListGroup } from '../../../api-new/state/content'
import { useLoad } from '../../hooks/load'
import { FormSelectObj } from '../form-select-obj'
import { useGetWatchValue } from '../hooks/input-hooks'
import { useManagedGroups } from '../../scim/managed-groups'

// A group to pick (a sign-up form's or a trade show's group). Groups the
// identity provider manages (SCIM Groups) aren't offered: it adds and
// removes their members. One already chosen stays listed, so a form saved
// before keeps showing its group; nothing else is offered until the managed
// list is read.
export const FormSelectGroupID = ({ label, name, required }) => {
  const apiListGroup = useApiListGroup()
  const { managed, ready } = useManagedGroups()
  const current = Number(useGetWatchValue(name))

  useLoad(() => apiListGroup.get(), [])

  const state = useMemo(
    () => ({ ...apiListGroup, items: (apiListGroup.items || []).filter(g => Number(g.id) === current || (ready && managed(g.id) === null)) }),
    [apiListGroup, managed, ready, current]
  )

  return <FormSelectObj label={label} name={name} itemName="name" itemValue="id" state={state} valueAsNumber required={required} />
}
